import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { useToast } from 'vue-toastification';
import { RootState } from '..';
import { Download } from './download.model';
import downloadService from './download.service';

// namespace
export const DOWNLOAD_STORE_NAMESPACE = 'downloadStore';

// state
interface DownloadState {
  downloads: Download[];
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: DownloadState = {
  downloads: [],
  status: 'init'
};

// mutation
const mutationConstant = {
  FETCH: 'fetch',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

const mutation: MutationTree<DownloadState> = {
  [mutationConstant.FETCH]: (state: DownloadState, downloads: Download[]) => {
    state.downloads = downloads;
  },
  [mutationConstant.PENDING]: (state: DownloadState) => {
    state.status = 'loading';
  },
  [mutationConstant.FULFILLED]: (state: DownloadState) => {
    state.status = 'idle';
  },
  [mutationConstant.REJECTED]: (state: DownloadState) => {
    state.status = 'failed';
  },
};

// action
const toast = useToast();
const actionConstant = {
  FETCH: 'fetch',
};

const action: ActionTree<DownloadState, RootState> = {
  [actionConstant.FETCH](context: ActionContext<DownloadState, RootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      downloadService.Fetch()
        .then((response) => {
          context.commit(mutationConstant.FETCH, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  },
};

// getter
const getterConstant = {
  ALL: 'all',
  BY_ID: 'byId',
  STATUS: 'status'
};

const getter: GetterTree<DownloadState, RootState> = {
  [getterConstant.ALL]: (state: DownloadState) => state.downloads,
  [getterConstant.BY_ID]: (state: DownloadState) => (id: number) => state.downloads.find(m => m.id === id),
  [getterConstant.STATUS]: (state: DownloadState) => state.status,
};

// module
const module: Module<DownloadState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const DownloadGetter = {
  ALL: `${DOWNLOAD_STORE_NAMESPACE}/${getterConstant.ALL}`,
  BY_ID: `${DOWNLOAD_STORE_NAMESPACE}/${getterConstant.BY_ID}`,
  STATUS: `${DOWNLOAD_STORE_NAMESPACE}/${getterConstant.STATUS}`
};

export const DownloadAction = {
  FETCH: `${DOWNLOAD_STORE_NAMESPACE}/${actionConstant.FETCH}`,
};

export default module;
